<!-- eslint-disable max-len -->
<template>
  <div
      class="
      block
      relative
      walter-block
      bg-white
      mb-2
      overflow-hiddens
      accordian-block
    "
  >
    <div class="card tab">
      <input
          id="tab-single3"
          class="card-heading absolute opacity-0"
          type="checkbox"
          name="tabs1"
      />
      <label
          class="
          card-heading
          cursor-pointer
          flex
          items-center
          justify-between
          mb-0
          pt-3
          pb-3
          rounded-t-lg
          tab
          w-full
          border-b
          solid
          border-agray1
        "
          for="tab-single3"
      >
        <span class="block relative text-sm font-bold text-darkblack">
          {{ $t("pages.questionnaire.third_collapse.label") }}
        </span>
        <span class="flex transform rotate-180 duration-100 iconbox">
          <svg
              class="w-4 h-4"
              viewBox="0 0 16 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M14.4957 7.50767C14.3637 7.50455 14.2382 7.44932 14.1467 7.35403L8.00025 1.20754L1.85377 7.35403C1.80716 7.40202 1.7514 7.44018 1.68978 7.46623C1.62817 7.49229 1.56195 7.50572 1.49505 7.50572C1.39554 7.5057 1.2983 7.47598 1.21577 7.42039C1.13325 7.36479 1.06919 7.28583 1.03178 7.19362C0.994383 7.10141 0.985343 7.00014 1.00582 6.90276C1.0263 6.80538 1.07536 6.71633 1.14674 6.647L7.64674 0.146995C7.74051 0.0532622 7.86767 0.000607491 8.00025 0.000607491C8.13284 0.000607491 8.26 0.0532622 8.35377 0.146995L14.8538 6.647C14.9265 6.71678 14.9764 6.80691 14.997 6.90556C15.0176 7.00422 15.0079 7.10679 14.9692 7.19984C14.9305 7.29289 14.8646 7.37207 14.7801 7.427C14.6956 7.48193 14.5964 7.51005 14.4957 7.50767Z"
                fill="white"
            ></path>
          </svg>
        </span>
      </label>
      <div class="tab-content overflow-hidden card-body rounded-b-lg">
        <div class="block relative pl-4 pr-4 pt-2 pb-4">
          <div class="block relative form-group-main">
            <div
                class="block relative mb-4 form-group"
                v-if="details.scope_of_services.information_on_site"
            >
              <label
                  class="
                  block
                  relative
                  text-sm
                  font-semibold
                  text-darkblack
                  mb-1
                "
              >
                {{ $t("pages.questionnaire.third_collapse.information") }}
              </label>
              <label
                  class="
                  block
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                  mb-0
                "
              >
                {{ details.scope_of_services.information_on_site }}
              </label>
            </div>

            <div class="block relative mb-4 form-group">
              <label
                  class="
                  block
                  relative
                  text-sm
                  font-semibold
                  text-darkblack
                  mb-1
                "
              >
                {{ $t("pages.questionnaire.third_collapse.mission_title") }}
              </label>
              <label
                  class="
                  block
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                  mb-0
                "
              >
                {{ details.patients[0].night_operations }}
              </label>
            </div>

          </div>

          <div
              class="block relative form-group"
              v-if="details.questionnaire_type === 'new'"
          >
            <div
                class="
                flex
                items-center
                justify-start
                relative
                mb-4
                titletop-block
              "
            >
              <div class="w-4/6">
                <label class="block text-base font-bold text-darkgreen">
                  {{ $t("pages.questionnaire.third_collapse.activity") }}
                </label>
              </div>
              <div class="w-2/6">
                <label
                    class="block text-sm font-medium text-darkgreen text-right"
                    @click="activityTime = ''"
                >
                  {{ $t("pages.questionnaire.third_collapse.all") }}
                </label>
              </div>
            </div>

            <div class="selectoin-block block relative mb-4">
              <div class="flex items-center justify-between flex-wrap">
                <label
                    class="
                    flex
                    items-center
                    justify-start
                    border
                    solid
                    border-color
                    pt-1.5
                    pb-1.5
                    pl-1
                    pr-1
                    rounded
                    mr-1
                    text-xs
                    font-normal
                  "
                    :class="
                    activityTime === 'morning'
                      ? 'text-white bg-green'
                      : 'text-darkgray1'
                  "
                    @click="activityTime = 'morning'"
                >
                  <span class="flex mr-1">
                    <svg
                        class="w-4 h-4"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                            d="M7.67497 1.5402L6.22985 2.99047C6.10294 3.11784 5.8969 3.11789 5.77006 2.99043M7.67497 1.5402L5.77006 2.99043M7.67497 1.5402V5.26923C7.67497 5.44889 7.8203 5.59514 7.99997 5.59514C8.17965 5.59514 8.32497 5.44889 8.32497 5.26923V1.5402L9.77009 2.99046C9.89703 3.11786 10.1029 3.11786 10.2299 2.99046C10.3566 2.86322 10.3566 2.65705 10.2299 2.52981L8.23012 0.522806M7.67497 1.5402L8.23012 0.522806M5.77006 2.99043C5.64331 2.86318 5.64332 2.65704 5.77009 2.52981L7.76997 0.522659C7.82862 0.463797 7.90997 0.426953 7.99997 0.426953C8.08978 0.426953 8.17144 0.463658 8.22998 0.522659M5.77006 2.99043L8.22998 0.522659M8.22998 0.522659L8.23012 0.522806M8.22998 0.522659L8.23012 0.522806M10.8208 14.9798H5.17916C5.03174 14.621 4.95 14.2283 4.95 13.8166C4.95 12.1284 6.31855 10.7552 8 10.7552C9.68145 10.7552 11.05 12.1284 11.05 13.8166C11.05 14.2283 10.9682 14.621 10.8208 14.9798ZM4.4862 14.9798H0.25C0.0703224 14.9798 -0.075 15.1261 -0.075 15.3058C-0.075 15.4854 0.0703224 15.6317 0.25 15.6317H15.75C15.9297 15.6317 16.075 15.4854 16.075 15.3058C16.075 15.1261 15.9297 14.9798 15.75 14.9798H11.5138C11.6347 14.6137 11.7 14.2227 11.7 13.8166C11.7 11.7694 10.0404 10.1034 8 10.1034C5.95945 10.1034 4.3 11.7694 4.3 13.8166C4.3 14.2227 4.36555 14.6137 4.4862 14.9798ZM11.6173 10.647L11.6174 10.6469L12.5965 8.84844L12.5434 8.7955L12.5433 8.79553L11.1576 10.1863C11.0308 10.3135 11.0308 10.5196 11.1575 10.6469C11.2209 10.7107 11.3043 10.7425 11.3875 10.7425C11.4707 10.7425 11.5538 10.7106 11.6173 10.647ZM8 9.33451C8.17968 9.33451 8.325 9.18827 8.325 9.0086V7.04173C8.325 6.86206 8.17968 6.71582 8 6.71582C7.82032 6.71582 7.675 6.86206 7.675 7.04173V9.0086C7.675 9.18827 7.82032 9.33451 8 9.33451ZM12.4652 13.8161C12.4652 13.9958 12.6106 14.142 12.7902 14.142H14.75C14.9297 14.142 15.075 13.9958 15.075 13.8161C15.075 13.6364 14.9297 13.4902 14.75 13.4902H12.7902C12.6106 13.4902 12.4652 13.6361 12.4652 13.8161ZM1.25 14.142H3.20975C3.38943 14.142 3.53475 13.9958 3.53475 13.8161C3.53475 13.6364 3.38943 13.4902 3.20975 13.4902H1.25C1.07032 13.4902 0.925 13.6364 0.925 13.8161C0.925 13.9958 1.07032 14.142 1.25 14.142ZM4.38291 10.6469C4.44638 10.7106 4.5296 10.7425 4.61279 10.7425C4.69591 10.7425 4.77932 10.7107 4.84273 10.6469C4.96945 10.5196 4.96943 10.3135 4.84266 10.1863L3.45692 8.7955C3.33 8.66812 3.12396 8.66807 2.99712 8.79553C2.87037 8.92278 2.87038 9.12892 2.99716 9.25616L4.38291 10.6469Z"
                            :fill="
                            activityTime === 'morning' ? '#fff' : '#63B15B'
                          "
                            :stroke="
                            activityTime === 'morning' ? '#fff' : '#63B15B'
                          "
                            stroke-width="0.15"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  {{ $t("pages.common.buttons.dis35") }}
                </label>

                <label
                    class="
                    flex
                    items-center
                    justify-start
                    border
                    solid
                    border-color
                    pt-1.5
                    pb-1.5
                    pl-1
                    pr-1
                    rounded
                    mr-1
                    text-xs
                    font-normal
                  "
                    :class="
                    activityTime === 'noon'
                      ? 'text-white bg-green'
                      : 'text-darkgray1'
                  "
                    @click="activityTime = 'noon'"
                >
                  <span class="flex mr-1">
                    <svg
                        class="w-3.5 h-3.5"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M7 3.5C5.07 3.5 3.5 5.07 3.5 7C3.5 8.93 5.07 10.5 7 10.5C8.93 10.5 10.5 8.93 10.5 7C10.5 5.07 8.93 3.5 7 3.5ZM7 9.5C5.6215 9.5 4.5 8.3785 4.5 7C4.5 5.6215 5.6215 4.5 7 4.5C8.3785 4.5 9.5 5.6215 9.5 7C9.5 8.3785 8.3785 9.5 7 9.5Z"
                          :fill="activityTime === 'noon' ? '#fff' : '#63B15B'"
                      />
                      <path
                          d="M7 2.5C7.276 2.5 7.5 2.276 7.5 2V1C7.5 0.724 7.276 0.5 7 0.5C6.724 0.5 6.5 0.724 6.5 1V2C6.5 2.276 6.724 2.5 7 2.5Z"
                          :fill="activityTime === 'noon' ? '#fff' : '#63B15B'"
                      />
                      <path
                          d="M7 11.5C6.724 11.5 6.5 11.724 6.5 12V13C6.5 13.276 6.724 13.5 7 13.5C7.276 13.5 7.5 13.276 7.5 13V12C7.5 11.724 7.276 11.5 7 11.5Z"
                          :fill="activityTime === 'noon' ? '#fff' : '#63B15B'"
                      />
                      <path
                          d="M13 6.5H12C11.724 6.5 11.5 6.724 11.5 7C11.5 7.276 11.724 7.5 12 7.5H13C13.276 7.5 13.5 7.276 13.5 7C13.5 6.724 13.276 6.5 13 6.5Z"
                          :fill="activityTime === 'noon' ? '#fff' : '#63B15B'"
                      />
                      <path
                          d="M2.5 7C2.5 6.724 2.276 6.5 2 6.5H1C0.724 6.5 0.5 6.724 0.5 7C0.5 7.276 0.724 7.5 1 7.5H2C2.276 7.5 2.5 7.276 2.5 7Z"
                          :fill="activityTime === 'noon' ? '#fff' : '#63B15B'"
                      />
                      <path
                          d="M10.5357 3.96516C10.6637 3.96516 10.7915 3.91641 10.8892 3.81866L11.5962 3.11141C11.7915 2.91616 11.7915 2.59966 11.5962 2.40416C11.401 2.20916 11.0845 2.20891 10.8892 2.40416L10.1822 3.11141C9.98695 3.30666 9.98695 3.62316 10.1822 3.81866C10.2797 3.91641 10.4077 3.96516 10.5357 3.96516Z"
                          :fill="activityTime === 'noon' ? '#fff' : '#63B15B'"
                      />
                      <path
                          d="M3.11095 10.1818L2.4037 10.8888C2.20845 11.0838 2.20845 11.4005 2.4037 11.5958C2.50145 11.6935 2.62945 11.7423 2.75745 11.7423C2.88545 11.7423 3.0132 11.6935 3.11095 11.5958L3.8182 10.8888C4.01345 10.6938 4.01345 10.377 3.8182 10.1818C3.6227 9.98628 3.3062 9.98628 3.11095 10.1818Z"
                          :fill="activityTime === 'noon' ? '#fff' : '#63B15B'"
                      />
                      <path
                          d="M10.8892 10.1816C10.694 9.98634 10.3775 9.98634 10.1822 10.1816C9.98695 10.3768 9.98695 10.6933 10.1822 10.8886L10.8892 11.5956C10.987 11.6933 11.1147 11.7421 11.2427 11.7421C11.3707 11.7421 11.4985 11.6933 11.5962 11.5956C11.7915 11.4003 11.7915 11.0838 11.5962 10.8886L10.8892 10.1816Z"
                          :fill="activityTime === 'noon' ? '#fff' : '#63B15B'"
                      />
                      <path
                          d="M3.11095 3.8185C3.20845 3.91625 3.33645 3.965 3.46445 3.965C3.59245 3.965 3.72045 3.91625 3.81795 3.8185C4.0132 3.62325 4.0132 3.30675 3.81795 3.1115L3.1107 2.40425C2.9157 2.209 2.5987 2.209 2.4037 2.40425C2.20845 2.5995 2.20845 2.916 2.4037 3.11125L3.11095 3.8185Z"
                          :fill="activityTime === 'noon' ? '#fff' : '#63B15B'"
                      />
                    </svg>
                  </span>
                  {{ $t("pages.common.buttons.dis100") }}
                </label>

                <label
                    class="
                    flex
                    items-center
                    justify-start
                    border
                    solid
                    border-color
                    pt-1.5
                    pb-1.5
                    pl-1
                    pr-1
                    rounded
                    mr-1
                    text-xs
                    font-normal
                  "
                    :class="
                    activityTime === 'evening'
                      ? 'text-white bg-green'
                      : 'text-darkgray1'
                  "
                    @click="activityTime = 'evening'"
                >
                  <span class="flex mr-1">
                    <svg
                        class="w-4 h-2.5"
                        viewBox="0 0 16 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M10.8017 9.02468L10.782 9.07063L10.8168 9.10651L11.0643 9.36156L11.114 9.41277L11.1676 9.36568L11.458 9.11063L11.4725 9.09792L11.479 9.07982C11.6221 8.68499 11.7 8.25946 11.7 7.81592C11.7 5.76873 10.0404 4.10273 8 4.10273C5.95945 4.10273 4.3 5.76874 4.3 7.81592C4.3 8.25949 4.3782 8.685 4.52097 9.07978L4.52757 9.09803L4.54218 9.11078L4.84606 9.37599L4.90226 9.42505L4.95161 9.36911L5.18561 9.1039L5.21703 9.06829L5.19828 9.02466C5.03882 8.65365 4.95 8.24507 4.95 7.81592C4.95 6.12769 6.31855 4.75455 8 4.75455C9.68145 4.75455 11.05 6.12769 11.05 7.81592C11.05 8.24505 10.9611 8.65365 10.8017 9.02468Z"
                          :fill="activityTime === 'evening' ? '#fff' : '#63B15B'"
                          :stroke="
                          activityTime === 'evening' ? '#fff' : '#63B15B'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M8 3.33471C8.17968 3.33471 8.325 3.18846 8.325 3.0088V1.04192C8.325 0.862258 8.17968 0.716016 8 0.716016C7.82032 0.716016 7.675 0.862258 7.675 1.04192V3.0088C7.675 3.18846 7.82032 3.33471 8 3.33471Z"
                          :fill="activityTime === 'evening' ? '#fff' : '#63B15B'"
                          :stroke="
                          activityTime === 'evening' ? '#fff' : '#63B15B'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M12.4652 7.81536C12.4652 7.99503 12.6105 8.14127 12.7902 8.14127H14.75C14.9297 8.14127 15.075 7.99503 15.075 7.81536C15.075 7.6357 14.9297 7.48945 14.75 7.48945H12.7902C12.6106 7.48945 12.4652 7.6354 12.4652 7.81536Z"
                          :fill="activityTime === 'evening' ? '#fff' : '#63B15B'"
                          :stroke="
                          activityTime === 'evening' ? '#fff' : '#63B15B'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M1.25 8.14127H3.20975C3.38943 8.14127 3.53475 7.99503 3.53475 7.81536C3.53475 7.6357 3.38943 7.48945 3.20975 7.48945H1.25C1.07032 7.48945 0.925 7.6357 0.925 7.81536C0.925 7.99503 1.07032 8.14127 1.25 8.14127Z"
                          :fill="activityTime === 'evening' ? '#fff' : '#63B15B'"
                          :stroke="
                          activityTime === 'evening' ? '#fff' : '#63B15B'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M11.1575 4.64732C11.2209 4.71117 11.3043 4.74297 11.3875 4.74297C11.4707 4.74297 11.5538 4.71105 11.6173 4.64745L11.6174 4.64739L12.5433 2.79597L11.1576 4.18673C11.0308 4.31395 11.0308 4.52007 11.1575 4.64732ZM11.1575 4.64732C11.1575 4.6473 11.1575 4.64727 11.1575 4.64725L11.2107 4.59445L11.1576 4.64739C11.1576 4.64736 11.1576 4.64734 11.1575 4.64732Z"
                          :fill="activityTime === 'evening' ? '#fff' : '#63B15B'"
                          :stroke="
                          activityTime === 'evening' ? '#fff' : '#63B15B'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M4.61277 4.74297C4.52959 4.74297 4.44636 4.71109 4.38289 4.64739L2.99714 3.2566C2.87037 3.12936 2.87035 2.92322 2.99711 2.79597L4.61277 4.74297ZM4.61277 4.74297C4.69589 4.74297 4.7793 4.71113 4.84272 4.64732M4.61277 4.74297L4.84272 4.64732M4.84272 4.64732L4.78952 4.59445M4.84272 4.64732L4.78952 4.59445M4.78952 4.59445L4.84265 4.64739C4.96943 4.52014 4.96943 4.31397 4.84265 4.18673M4.78952 4.59445C4.74077 4.6435 4.67677 4.66797 4.61277 4.66797C4.54877 4.66797 4.48489 4.6435 4.43602 4.59445L3.05027 3.20366C2.95264 3.10568 2.95264 2.94686 3.05027 2.84888C3.14777 2.7509 3.30614 2.7509 3.40377 2.84888L4.78952 4.23966L4.84265 4.18673M4.84265 4.18673L3.4569 2.79594M4.84265 4.18673L3.4569 2.79594M3.4569 2.79594C3.32999 2.66857 3.12398 2.66851 2.99714 2.79594L3.4569 2.79594Z"
                          :fill="activityTime === 'evening' ? '#fff' : '#63B15B'"
                          :stroke="
                          activityTime === 'evening' ? '#fff' : '#63B15B'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M15.75 8.97969H0.25C0.0703223 8.97969 -0.075 9.12593 -0.075 9.3056C-0.075 9.48526 0.0703223 9.63151 0.25 9.63151H15.75C15.9297 9.63151 16.075 9.48526 16.075 9.3056C16.075 9.12593 15.9297 8.97969 15.75 8.97969Z"
                          :fill="activityTime === 'evening' ? '#fff' : '#63B15B'"
                          :stroke="
                          activityTime === 'evening' ? '#fff' : '#63B15B'
                        "
                          stroke-width="0.15"
                      />
                    </svg>
                  </span>
                  {{ $t("pages.common.buttons.dis36") }}
                </label>

                <label
                    class="
                    flex
                    items-center
                    justify-start
                    border
                    solid
                    border-color
                    pt-1.5
                    pb-1.5
                    pl-1
                    pr-1
                    rounded
                    text-xs
                    font-normal
                  "
                    :class="
                    activityTime === 'night'
                      ? 'text-white bg-green'
                      : 'text-darkgray1'
                  "
                    @click="activityTime = 'night'"
                >
                  <span class="flex mr-1">
                    <svg
                        class="w-3.5 h-3.5"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M4.66043 0.439794C4.61083 0.442234 4.56191 0.452355 4.51542 0.469794C1.92728 1.42895 0.44043 3.94354 0.44043 6.80479C0.44043 10.5291 3.46611 13.5598 7.19041 13.5598C10.0517 13.5598 12.5713 12.068 13.5304 9.47979C13.5622 9.39265 13.5681 9.29815 13.5473 9.20773C13.5266 9.11732 13.48 9.03486 13.4134 8.97033C13.3467 8.9058 13.2628 8.86196 13.1718 8.84412C13.0808 8.82628 12.9865 8.8352 12.9004 8.86979C12.2455 9.13319 11.5252 9.26979 10.7654 9.26979C7.62992 9.26979 4.73041 6.36528 4.73041 3.22979C4.73041 2.46997 4.86203 1.74973 5.12542 1.0948C5.15453 1.0206 5.1647 0.940319 5.15502 0.861201C5.14534 0.782082 5.11611 0.706617 5.06997 0.64162C5.02383 0.576624 4.96223 0.52414 4.89073 0.488906C4.81923 0.453671 4.74008 0.436789 4.66043 0.439794ZM3.91542 1.8348C3.82227 2.28666 3.77041 2.75261 3.77041 3.22979C3.77041 6.94353 7.05168 10.2298 10.7654 10.2298C11.2426 10.2298 11.7086 10.1729 12.1604 10.0798C11.1579 11.6876 9.33753 12.5998 7.19041 12.5998C3.98494 12.5998 1.40043 10.0103 1.40043 6.80479C1.40043 4.65743 2.30729 2.83724 3.91542 1.8348Z"
                          :fill="activityTime === 'night' ? '#fff' : '#63B15B'"
                      />
                    </svg>
                  </span>
                  {{ $t("pages.common.buttons.dis37") }}
                </label>
              </div>
            </div>
          </div>

          <div
              v-if="nursingActivities.length > 0"
              class="block relative pb-2 border-b solid border-agray1"
          >
            <div
                v-for="(nursingActivity, key) in nursingActivities"
                :key="`nursingActivity${key}`"
                class="flex items-center justify-start form-item mb-4"
            >
              <div class="w-3/5">
                <label
                    class="block text-sm font-semibold text-darkblack"
                >
                  {{ nursingActivity }}
                </label>
              </div>
              <div class="w-2/5">
                <div class="flex items-center justify-end flex-wrap">
                  <span class="flex mr-3">
                    <svg
                        class="w-4 h-4"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M7.67497 1.5402L6.22985 2.99047C6.10294 3.11784 5.8969 3.11789 5.77006 2.99043M7.67497 1.5402L5.77006 2.99043M7.67497 1.5402V5.26923C7.67497 5.44889 7.8203 5.59514 7.99997 5.59514C8.17965 5.59514 8.32497 5.44889 8.32497 5.26923V1.5402L9.77009 2.99046C9.89703 3.11786 10.1029 3.11786 10.2299 2.99046C10.3566 2.86322 10.3566 2.65705 10.2299 2.52981L8.23012 0.522806M7.67497 1.5402L8.23012 0.522806M5.77006 2.99043C5.64331 2.86318 5.64332 2.65704 5.77009 2.52981L7.76997 0.522659C7.82862 0.463797 7.90997 0.426953 7.99997 0.426953C8.08978 0.426953 8.17144 0.463658 8.22998 0.522659M5.77006 2.99043L8.22998 0.522659M8.22998 0.522659L8.23012 0.522806M8.22998 0.522659L8.23012 0.522806M10.8208 14.9798H5.17916C5.03174 14.621 4.95 14.2283 4.95 13.8166C4.95 12.1284 6.31855 10.7552 8 10.7552C9.68145 10.7552 11.05 12.1284 11.05 13.8166C11.05 14.2283 10.9682 14.621 10.8208 14.9798ZM4.4862 14.9798H0.25C0.0703224 14.9798 -0.075 15.1261 -0.075 15.3058C-0.075 15.4854 0.0703224 15.6317 0.25 15.6317H15.75C15.9297 15.6317 16.075 15.4854 16.075 15.3058C16.075 15.1261 15.9297 14.9798 15.75 14.9798H11.5138C11.6347 14.6137 11.7 14.2227 11.7 13.8166C11.7 11.7694 10.0404 10.1034 8 10.1034C5.95945 10.1034 4.3 11.7694 4.3 13.8166C4.3 14.2227 4.36555 14.6137 4.4862 14.9798ZM11.6173 10.647L11.6174 10.6469L12.5965 8.84844L12.5434 8.7955L12.5433 8.79553L11.1576 10.1863C11.0308 10.3135 11.0308 10.5196 11.1575 10.6469C11.2209 10.7107 11.3043 10.7425 11.3875 10.7425C11.4707 10.7425 11.5538 10.7106 11.6173 10.647ZM8 9.33451C8.17968 9.33451 8.325 9.18827 8.325 9.0086V7.04173C8.325 6.86206 8.17968 6.71582 8 6.71582C7.82032 6.71582 7.675 6.86206 7.675 7.04173V9.0086C7.675 9.18827 7.82032 9.33451 8 9.33451ZM12.4652 13.8161C12.4652 13.9958 12.6106 14.142 12.7902 14.142H14.75C14.9297 14.142 15.075 13.9958 15.075 13.8161C15.075 13.6364 14.9297 13.4902 14.75 13.4902H12.7902C12.6106 13.4902 12.4652 13.6361 12.4652 13.8161ZM1.25 14.142H3.20975C3.38943 14.142 3.53475 13.9958 3.53475 13.8161C3.53475 13.6364 3.38943 13.4902 3.20975 13.4902H1.25C1.07032 13.4902 0.925 13.6364 0.925 13.8161C0.925 13.9958 1.07032 14.142 1.25 14.142ZM4.38291 10.6469C4.44638 10.7106 4.5296 10.7425 4.61279 10.7425C4.69591 10.7425 4.77932 10.7107 4.84273 10.6469C4.96945 10.5196 4.96943 10.3135 4.84266 10.1863L3.45692 8.7955C3.33 8.66812 3.12396 8.66807 2.99712 8.79553C2.87037 8.92278 2.87038 9.12892 2.99716 9.25616L4.38291 10.6469Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.morning.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.morning.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          stroke-width="0.15"
                      />
                    </svg>
                  </span>

                  <span class="flex mr-3">
                    <svg
                        class="w-3.5 h-3.5"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M7 3.5C5.07 3.5 3.5 5.07 3.5 7C3.5 8.93 5.07 10.5 7 10.5C8.93 10.5 10.5 8.93 10.5 7C10.5 5.07 8.93 3.5 7 3.5ZM7 9.5C5.6215 9.5 4.5 8.3785 4.5 7C4.5 5.6215 5.6215 4.5 7 4.5C8.3785 4.5 9.5 5.6215 9.5 7C9.5 8.3785 8.3785 9.5 7 9.5Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.noon.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                      <path
                          d="M7 2.5C7.276 2.5 7.5 2.276 7.5 2V1C7.5 0.724 7.276 0.5 7 0.5C6.724 0.5 6.5 0.724 6.5 1V2C6.5 2.276 6.724 2.5 7 2.5Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.noon.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                      <path
                          d="M7 11.5C6.724 11.5 6.5 11.724 6.5 12V13C6.5 13.276 6.724 13.5 7 13.5C7.276 13.5 7.5 13.276 7.5 13V12C7.5 11.724 7.276 11.5 7 11.5Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.noon.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                      <path
                          d="M13 6.5H12C11.724 6.5 11.5 6.724 11.5 7C11.5 7.276 11.724 7.5 12 7.5H13C13.276 7.5 13.5 7.276 13.5 7C13.5 6.724 13.276 6.5 13 6.5Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.noon.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                      <path
                          d="M2.5 7C2.5 6.724 2.276 6.5 2 6.5H1C0.724 6.5 0.5 6.724 0.5 7C0.5 7.276 0.724 7.5 1 7.5H2C2.276 7.5 2.5 7.276 2.5 7Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.noon.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                      <path
                          d="M10.5357 3.96516C10.6637 3.96516 10.7915 3.91641 10.8892 3.81866L11.5962 3.11141C11.7915 2.91616 11.7915 2.59966 11.5962 2.40416C11.401 2.20916 11.0845 2.20891 10.8892 2.40416L10.1822 3.11141C9.98695 3.30666 9.98695 3.62316 10.1822 3.81866C10.2797 3.91641 10.4077 3.96516 10.5357 3.96516Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.noon.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                      <path
                          d="M3.11095 10.1818L2.4037 10.8888C2.20845 11.0838 2.20845 11.4005 2.4037 11.5958C2.50145 11.6935 2.62945 11.7423 2.75745 11.7423C2.88545 11.7423 3.0132 11.6935 3.11095 11.5958L3.8182 10.8888C4.01345 10.6938 4.01345 10.377 3.8182 10.1818C3.6227 9.98628 3.3062 9.98628 3.11095 10.1818Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.noon.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                      <path
                          d="M10.8892 10.1816C10.694 9.98634 10.3775 9.98634 10.1822 10.1816C9.98695 10.3768 9.98695 10.6933 10.1822 10.8886L10.8892 11.5956C10.987 11.6933 11.1147 11.7421 11.2427 11.7421C11.3707 11.7421 11.4985 11.6933 11.5962 11.5956C11.7915 11.4003 11.7915 11.0838 11.5962 10.8886L10.8892 10.1816Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.noon.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                      <path
                          d="M3.11095 3.8185C3.20845 3.91625 3.33645 3.965 3.46445 3.965C3.59245 3.965 3.72045 3.91625 3.81795 3.8185C4.0132 3.62325 4.0132 3.30675 3.81795 3.1115L3.1107 2.40425C2.9157 2.209 2.5987 2.209 2.4037 2.40425C2.20845 2.5995 2.20845 2.916 2.4037 3.11125L3.11095 3.8185Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.noon.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                    </svg>
                  </span>

                  <span class="flex mr-3">
                    <svg
                        class="w-4 h-4"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M10.8017 15.0247L10.782 15.0706L10.8168 15.1065L11.0643 15.3616L11.114 15.4128L11.1676 15.3657L11.458 15.1106L11.4725 15.0979L11.479 15.0798C11.6221 14.685 11.7 14.2595 11.7 13.8159C11.7 11.7687 10.0404 10.1027 8 10.1027C5.95945 10.1027 4.3 11.7687 4.3 13.8159C4.3 14.2595 4.3782 14.685 4.52097 15.0798L4.52757 15.098L4.54218 15.1108L4.84606 15.376L4.90226 15.425L4.95161 15.3691L5.18561 15.1039L5.21703 15.0683L5.19828 15.0247C5.03882 14.6537 4.95 14.2451 4.95 13.8159C4.95 12.1277 6.31855 10.7546 8 10.7546C9.68145 10.7546 11.05 12.1277 11.05 13.8159C11.05 14.2451 10.9611 14.6536 10.8017 15.0247Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M8 9.33471C8.17968 9.33471 8.325 9.18846 8.325 9.0088V7.04192C8.325 6.86226 8.17968 6.71602 8 6.71602C7.82032 6.71602 7.675 6.86226 7.675 7.04192V9.0088C7.675 9.18846 7.82032 9.33471 8 9.33471Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M12.4652 13.8154C12.4652 13.995 12.6105 14.1413 12.7902 14.1413H14.75C14.9297 14.1413 15.075 13.995 15.075 13.8154C15.075 13.6357 14.9297 13.4895 14.75 13.4895H12.7902C12.6106 13.4895 12.4652 13.6354 12.4652 13.8154Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M1.25 14.1413H3.20975C3.38943 14.1413 3.53475 13.995 3.53475 13.8154C3.53475 13.6357 3.38943 13.4895 3.20975 13.4895H1.25C1.07032 13.4895 0.925 13.6357 0.925 13.8154C0.925 13.995 1.07032 14.1413 1.25 14.1413Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M11.1575 10.6473C11.2209 10.7112 11.3043 10.743 11.3875 10.743C11.4707 10.743 11.5538 10.7111 11.6173 10.6475L11.6174 10.6474L12.5433 8.79597L11.1576 10.1867C11.0308 10.314 11.0308 10.5201 11.1575 10.6473ZM11.1575 10.6473C11.1575 10.6473 11.1575 10.6473 11.1575 10.6472L11.2107 10.5944L11.1576 10.6474C11.1576 10.6474 11.1576 10.6473 11.1575 10.6473Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M4.61277 10.743C4.52959 10.743 4.44636 10.7111 4.38289 10.6474L2.99714 9.2566C2.87037 9.12936 2.87035 8.92322 2.99711 8.79597L4.61277 10.743ZM4.61277 10.743C4.69589 10.743 4.7793 10.7111 4.84272 10.6473M4.61277 10.743L4.84272 10.6473M4.84272 10.6473L4.78952 10.5944M4.84272 10.6473L4.78952 10.5944M4.78952 10.5944L4.84265 10.6474C4.96943 10.5201 4.96943 10.314 4.84265 10.1867M4.78952 10.5944C4.74077 10.6435 4.67677 10.668 4.61277 10.668C4.54877 10.668 4.48489 10.6435 4.43602 10.5944L3.05027 9.20366C2.95264 9.10568 2.95264 8.94686 3.05027 8.84888C3.14777 8.7509 3.30614 8.7509 3.40377 8.84888L4.78952 10.2397L4.84265 10.1867M4.84265 10.1867L3.4569 8.79594M4.84265 10.1867L3.4569 8.79594M3.4569 8.79594C3.32999 8.66857 3.12398 8.66851 2.99714 8.79594L3.4569 8.79594Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M15.75 14.9797H0.25C0.0703223 14.9797 -0.075 15.1259 -0.075 15.3056C-0.075 15.4853 0.0703223 15.6315 0.25 15.6315H15.75C15.9297 15.6315 16.075 15.4853 16.075 15.3056C16.075 15.1259 15.9297 14.9797 15.75 14.9797Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          stroke-width="0.15"
                      />
                      <path
                          d="M9.77009 3.03162C9.89703 2.90423 10.1029 2.90423 10.2298 3.03162C10.3566 3.15887 10.3566 3.36504 10.2298 3.49228L8.23012 5.49928C8.23009 5.49931 8.23007 5.49934 8.23004 5.49936L8.22997 5.49943L8.17684 5.44649L9.77009 3.03162ZM9.77009 3.03162L8.32497 4.48188M9.77009 3.03162L8.32497 4.48188M8.32497 4.48188V0.752862C8.32497 0.573196 8.17965 0.426953 7.99997 0.426953C7.82029 0.426953 7.67497 0.573196 7.67497 0.752862V4.48188L6.22985 3.03162M8.32497 4.48188L6.22985 3.03162M6.22985 3.03162C6.10293 2.90425 5.89689 2.9042 5.77006 3.03166L6.22985 3.03162Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.evening.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          stroke-width="0.15"
                      />
                    </svg>
                  </span>

                  <span class="flex mr-0">
                    <svg
                        class="w-3.5 h-3.5"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M4.66043 0.439794C4.61083 0.442234 4.56191 0.452355 4.51542 0.469794C1.92728 1.42895 0.44043 3.94354 0.44043 6.80479C0.44043 10.5291 3.46611 13.5598 7.19041 13.5598C10.0517 13.5598 12.5713 12.068 13.5304 9.47979C13.5622 9.39265 13.5681 9.29815 13.5473 9.20773C13.5266 9.11732 13.48 9.03486 13.4134 8.97033C13.3467 8.9058 13.2628 8.86196 13.1718 8.84412C13.0808 8.82628 12.9865 8.8352 12.9004 8.86979C12.2455 9.13319 11.5252 9.26979 10.7654 9.26979C7.62992 9.26979 4.73041 6.36528 4.73041 3.22979C4.73041 2.46997 4.86203 1.74973 5.12542 1.0948C5.15453 1.0206 5.1647 0.940319 5.15502 0.861201C5.14534 0.782082 5.11611 0.706617 5.06997 0.64162C5.02383 0.576624 4.96223 0.52414 4.89073 0.488906C4.81923 0.453671 4.74008 0.436789 4.66043 0.439794ZM3.91542 1.8348C3.82227 2.28666 3.77041 2.75261 3.77041 3.22979C3.77041 6.94353 7.05168 10.2298 10.7654 10.2298C11.2426 10.2298 11.7086 10.1729 12.1604 10.0798C11.1579 11.6876 9.33753 12.5998 7.19041 12.5998C3.98494 12.5998 1.40043 10.0103 1.40043 6.80479C1.40043 4.65743 2.30729 2.83724 3.91542 1.8348Z"
                          :fill="
                          details.patients[
                            patientIdx - 1
                          ].activities.night.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                          :stroke="
                          details.patients[
                            patientIdx - 1
                          ].activities.night.includes(nursingActivity)
                            ? '#63B15B'
                            : '#C6C6D1'
                        "
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
              class="
              block
              relative
              w-full
              mt-2.5
              border-b
              solid
              border-agray1
              mb-2
            "
              v-if="details.questionnaire_type === 'new'"
          >
            <label class="block w-full text-base font-bold text-darkgreen mb-2">
              {{ $t("pages.questionnaire.third_collapse.household") }}
            </label>
            <div
                class="block relative form-group mb-2"
                v-if="details.scope_of_services.household.other_persons"
            >
              <label
                  class="block relative text-sm font-semibold text-darkblack mb-1"
              >
                {{
                  $t("pages.care_situation_detail1.third_collapse.question_one")
                }}
              </label>
              <label
                  class="
                  block
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                  mb-0
                "
              >
                {{ details.scope_of_services.household.other_persons }}
              </label>
            </div>
            <div
                class="block relative form-group mb-2"
                v-if="details.scope_of_services.household.who_are_these_people"
            >
              <label
                  class="block relative text-sm font-semibold text-darkblack mb-1"
              >
                {{
                  $t(
                      $t(
                          "pages.care_situation_detail1.third_collapse.question_two"
                      )
                  )
                }}
              </label>
              <label
                  class="
                  block
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                  mb-0
                "
              >
                {{ details.scope_of_services.household.who_are_these_people }}
              </label>
            </div>
            <div class="block relative form-group mb-2">
              <label
                  class="block relative text-sm font-semibold text-darkblack mb-1"
              >
                {{
                  $t(
                      $t(
                          "pages.care_situation_detail1.third_collapse.question_three"
                      )
                  )
                }}
              </label>
              <label
                  class="
                  block
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                  mb-0
                "
              >
                {{
                  details.help_family_members == true
                      ? $t("pages.common.buttons.dis106")
                      : $t("pages.common.buttons.dis107")
                }}
              </label>
            </div>
          </div>
          <label
              for=""
              class="
              block
              relative
              text-sm
              font-semibold
              text-darkblack
              mb-1
            "
              v-if="details.questionnaire_type === 'new'"
              style="border-style: none !important"
          >
            {{ $t("pages.common.buttons.dis133") }}
          </label>

          <ul
              class="block relative mb-2"
              v-if="details.questionnaire_type === 'new'"
          >
            <li class="list-block w-full mb-1">
              <label
                  v-for="items in detail.household"
                  :key="items"
                  class="
                  flex
                  items-center
                  justify-start
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                "
              >
                <span
                    class="
                    flex
                    items-start
                    justify-start
                    w-1.5
                    h-1.5
                    bg-grayblock
                    mr-2
                    rounded-full
                  "
                ></span>
                {{ items }}
              </label>
            </li>
          </ul>
          <hr/>
          <div v-if="details.questionnaire_type === 'new'">
            <div
                class="block relative form-group mb-2"
                v-if="details.household.normal_routine"
            >
              <label
                  class="block relative text-sm font-semibold text-darkblack mb-1"
              >
                {{
                  $t($t("pages.questionnaire.third_collapse.patientquestion"))
                }}
              </label>
              <label
                  class="
                  block
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                  mb-0
                "
              >
                {{ details.household.normal_routine }}
              </label>
            </div>
            <div class="block relative border-b solid border-agray1 mt-2">
              <label
                  class="block w-full text-base font-bold text-darkgreen mb-2"
              >
                {{ $t("pages.questionnaire.third_collapse.purchase") }}
              </label>
              <div
                  class="block relative form-group mb-2"
                  v-if="details.scope_of_services.purchases.do_shopping"
              >
                <label
                    class="
                    block
                    relative
                    text-sm
                    font-semibold
                    text-darkblack
                    mb-1
                  "
                >
                  {{
                    $t(
                        "pages.questionnaire.third_collapse.purchasefirstquestion"
                    )
                  }}
                </label>
                <label
                    class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                    mb-0
                  "
                >
                  {{ details.scope_of_services.purchases.do_shopping }}
                </label>
              </div>

              <div class="block relative form-group mb-2">
                <label
                    class="
                    block
                    relative
                    text-sm
                    font-semibold
                    text-darkblack
                    mb-1
                  "
                >
                  {{
                    $t(
                        "pages.questionnaire.third_collapse.purchasesecondquestion"
                    )
                  }}
                </label>

                <ul class="block relative mb-2">
                  <li
                      v-for="grocery_transport_option in details.scope_of_services.purchases
                      .grocery_transport_options"
                      :key="grocery_transport_option"
                      class="list-block w-full mb-1"
                  >
                    <label
                        class="
                  flex
                  items-center
                  justify-start
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                "
                    >
                <span
                    class="
                    flex
                    items-start
                    justify-start
                    w-1.5
                    h-1.5
                    bg-grayblock
                    mr-2
                    rounded-full
                  "
                ></span>
                      {{ grocery_transport_option }}
                    </label>
                  </li>
                </ul>
              </div>
              <div
                  class="block relative form-group mb-2"
                  v-if="details.scope_of_services.purchases.financing"
              >
                <label
                    class="
                    block
                    relative
                    text-sm
                    font-semibold
                    text-darkblack
                    mb-1
                  "
                >
                  {{
                    $t(
                        "pages.questionnaire.third_collapse.purchaseforthquestion"
                    )
                  }}
                </label>
                <label
                    class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                    mb-0
                  "
                >
                  {{ details.scope_of_services.purchases.financing }}
                </label>
              </div>

              <div
                  class="block relative form-group mb-2"
                  v-if="listItems.length < 0"
              >
                <label
                    class="
                    block
                    relative
                    text-sm
                    font-semibold
                    text-darkblack
                    mb-1
                  "
                >
                  {{ $t("pages.questionnaire.third_collapse.accessibility") }}
                </label>
                <ul class="block relative mb-2">
                  <li
                      class="list-block w-full mb-1"
                      v-for="datas in listItems"
                      :key="datas"
                  >
                    <label
                        class="
                        flex
                        items-center
                        justify-start
                        relative
                        text-sm
                        font-normal
                        text-darkgray1
                      "
                    >
                      <span
                          class="
                          flex
                          items-start
                          justify-start
                          w-1.5
                          h-1.5
                          bg-grayblock
                          mr-2
                          rounded-full
                        "
                      ></span>
                      {{ datas }}
                    </label>
                  </li>
                </ul>
              </div>
            </div>

            <div class="block relative mt-2">
              <div
                  class="block relative form-group mb-2"
                  v-if="details.other_requirements"
              >
                <label
                    class="block w-full text-base font-bold text-darkgreen mb-1"
                >
                  {{
                    $t("pages.questionnaire.third_collapse.other_requirement")
                  }}
                </label>
                <label
                    class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                    mb-0
                  "
                >
                  {{ details.other_requirements }}
                </label>
              </div>

              <div class="block relative form-group mb-0">
                <label
                    class="
                    block
                    relative
                    text-sm
                    font-semibold
                    text-darkblack
                    mb-1
                  "
                >
                  {{ $t("pages.questionnaire.third_collapse.normal_course") }}
                </label>
                <label
                    class="
                    block
                    relative
                    text-sm
                    font-normal
                    text-darkgray1
                    mb-0
                  "
                >
                  {{ details.normal_routine }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {isEmpty} from "lodash";
import {StorageService} from "@/services/storage.service";

export default {
  name: "ScopeOfServices",
  props: {
    details: {
      default: () => {
      },
      type: Object,
    },
    patientIdx: {
      default: 1,
      type: Number,
    },
  },
  data() {
    return {
      activityTime: "",
      detail: StorageService.get("offerDetails"),
      listItems: [],
    };
  },
  computed: {
    nursingActivities() {
      let activities = [
        ...new Set(
            [].concat(
                this.details.patients[this.patientIdx - 1].activities.morning,
                this.details.patients[this.patientIdx - 1].activities.noon,
                this.details.patients[this.patientIdx - 1].activities.evening,
                this.details.patients[this.patientIdx - 1].activities.night
            )
        ),
      ];

      if (!isEmpty(this.activityTime)) {
        activities = activities.filter((activity) => {
          return this.details.patients[this.patientIdx - 1].activities[
              this.activityTime
              ].includes(activity);
        });
      }
      return activities;
    },
  },
  created() {
    this.listItems =
        this.detail.scope_of_services.purchases.shopping_accessibility;
  },
};
</script>
